// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const SavedLists: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 28">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M0 1.5A1.5 1.5 0 0 1 1.5 0h3C5.331 0 6 .672 6 1.5v3C6 5.331 5.331 6 4.5 6h-3C.672 6 0 5.331 0 4.5v-3ZM4 4V2H2v2h2Zm27.955-2C32.53 2 33 2.448 33 3c0 .55-.47 1-1.045 1h-20.91C10.47 4 10 3.55 10 3c0-.552.47-1 1.045-1h20.91Zm0 11c.575 0 1.045.45 1.045 1s-.47 1-1.045 1h-20.91C10.47 15 10 14.55 10 14s.47-1 1.045-1h20.91Zm0 11c.575 0 1.045.45 1.045 1s-.47 1-1.045 1h-20.91C10.47 26 10 25.55 10 25s.47-1 1.045-1h20.91ZM4.5 11c.831 0 1.5.669 1.5 1.5v3c0 .831-.669 1.5-1.5 1.5h-3C.672 17 0 16.331 0 15.5v-3c0-.831.672-1.5 1.5-1.5h3ZM2 13v2h2v-2H2ZM0 23.5c0-.831.672-1.5 1.5-1.5h3c.831 0 1.5.669 1.5 1.5v3c0 .831-.669 1.5-1.5 1.5h-3C.672 28 0 27.331 0 26.5v-3ZM4 26v-2H2v2h2Z"
            />
        </svg>
    );
};

export default React.memo(SavedLists);
